module.exports = __webpack_public_path__ + "baf873efd98e3024f80c8714dc902fb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzak-5.jpg
// module id = 1187
// module chunks = 0